/* tslint:disable */
/* eslint-disable */
/**
 * Kontor API
 * OpenAPI specification for Kontor application framework
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * All object attributes
 * @export
 * @interface TicketPaymentDataAttributes
 */
export interface TicketPaymentDataAttributes {
    /**
     * Payment result
     * @type {string}
     * @memberof TicketPaymentDataAttributes
     */
    result: TicketPaymentDataAttributesResultEnum;
    /**
     * Unique ID of event related to this ticket payment
     * @type {string}
     * @memberof TicketPaymentDataAttributes
     */
    eventId: string;
    /**
     * Reference ID of current ticket payment
     * @type {string}
     * @memberof TicketPaymentDataAttributes
     */
    referenceId: string;
}

/**
* @export
* @enum {string}
*/
export enum TicketPaymentDataAttributesResultEnum {
    Successful = 'successful',
    Failed = 'failed',
    Cancelled = 'cancelled'
}

export function TicketPaymentDataAttributesFromJSON(json: any): TicketPaymentDataAttributes {
    return TicketPaymentDataAttributesFromJSONTyped(json, false);
}

export function TicketPaymentDataAttributesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketPaymentDataAttributes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': json['result'],
        'eventId': json['eventId'],
        'referenceId': json['referenceId'],
    };
}

export function TicketPaymentDataAttributesToJSON(value?: TicketPaymentDataAttributes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
        'eventId': value.eventId,
        'referenceId': value.referenceId,
    };
}

